import * as React from 'react';
import { useLocation, Link } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import TaxiAlertIcon from '@mui/icons-material/TaxiAlert';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import { useSelector } from 'react-redux';
import { PATROL, CONTROL_TOWER, CALL_HANDLER } from '../../../utils/config';
// import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
// import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
// import HelpRoundedIcon from '@mui/icons-material/HelpRounded';


// const secondaryListItems = [
//   { text: 'Settings', icon: <SettingsRoundedIcon /> },
//   { text: 'About', icon: <InfoRoundedIcon /> },
//   { text: 'Feedback', icon: <HelpRoundedIcon /> },
// ];

export default function MenuContent({ onClose }) {
  const location = useLocation();
  const { roles } = useSelector((state) => state.auth) || [];
  let mainListItems;
  if (!roles.length || (roles.length && (roles.includes(CALL_HANDLER) || roles.includes(CONTROL_TOWER)))) {

    mainListItems = [
      { text: 'Home', icon: <HomeRoundedIcon />, component: Link, to: "/" },
      { text: 'Tasks', icon: <TaxiAlertIcon />, component: Link, to: "/tasks" },
      { text: 'Patrols', icon: <AirportShuttleIcon />, component: Link, to: "/patrols" },
      { text: 'Completed Tasks', icon: <TaxiAlertIcon />, component: Link, to: "/completed-tasks" },
      // { text: 'Patrol UI', icon: <AirportShuttleIcon />, component: Link, to: "/patrol-ui" },
    ];
  }

  if (roles.length && (!roles.includes(CALL_HANDLER) && !roles.includes(CONTROL_TOWER)) && roles.includes(PATROL)) {
    mainListItems = [
      { text: 'Patrol UI', icon: <AirportShuttleIcon />, component: Link, to: "/patrol-ui" },
    ];
  }

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              component={item.component}
              to={item.to}
              selected={location.pathname === item.to}
              onClick={() => { if (onClose) onClose(); }}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

    </Stack>
  );
}
